import PaginatedTable from './PaginatedTable'
import SortableTable from './SortableTable'

export {
  PaginatedTable,
  SortableTable
}
